const manifest = require("../data/routeManifest.json");

const normalizePath = (path) => {
  const cleaned = path.replace(/\/+$/, "") || "/";
  return manifest.aliases?.[cleaned] || cleaned;
};
const publicPaths = new Set([
  ...manifest.publicPages,
  ...manifest.categories.map((slug) => `/shop/${slug}`),
  ...manifest.cities.map((slug) => `/livraison-${slug}`),
]);

function getRoutePolicy(pathname) {
  const path = normalizePath(pathname);
  if (publicPaths.has(path)) return { path, status: 200, indexable: true };
  if (manifest.technicalPages.includes(path) || /^\/order-confirmation\/[^/]+$/.test(path)) {
    return { path, status: 200, indexable: false };
  }
  return { path, status: 404, indexable: false };
}

module.exports = { getRoutePolicy, normalizePath };